export default __webpack_public_path__ + "static/media/editBlackIcon.3fc84d56.svg";